const SequenceType = {'None': 0, 'UAlphabet': 1, 'LAlphabet': 2, 'Numerical': 3}
Object.freeze(SequenceType)

const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const lowercase = 'abcdefghijklmnopqrstuvwxyz'
const numeric = '0123456789'


/**
 * @param {SequenceType} sequenceType
 * @return {string}
 */
function getPossibleValuesFromSequenceType(sequenceType) {
    switch (sequenceType) {
    case SequenceType.None:
        return uppercase
    case SequenceType.UAlphabet:
        return uppercase
    case SequenceType.LAlphabet:
        return lowercase
    case SequenceType.Numerical:
        return numeric
    default:
        break
    }
    return uppercase
}

/**
 * @param {string} name
 * @param {SequenceType} defaultValue
 * @return {SequenceType}
 */
function getSequenceType(name,
    defaultValue=SequenceType.UAlphabet) {
    if (name.length === 0) {
        return defaultValue
    }

    if (name[0].toLowerCase() !== name[0]) {
        return SequenceType.UAlphabet
    }

    if (name[0].toUpperCase() !== name[0]) {
        return SequenceType.LAlphabet
    }


    if (!isNaN(parseInt(name[0]))) {
        return SequenceType.Numerical
    }

    return SequenceType.None
}

class Section {
    constructor(values=[], type=SequenceType.None) {
        this.values = values
        this.type = type
    }

    copy() {
        return new Section(this.values.slice(), this.type)
    }

    equals(rhs) {
        if (rhs === null) {
            return false
        }
        if (this.type !== rhs.type) {
            return false
        }

        for (let i = 0; i < this.values.length; i++) {
            if (this.values[i] !== rhs.values[i]) {
                return false
            }
        }
        return true
    }

    addOne() {
        const values = getPossibleValuesFromSequenceType(this.type)
        for (let i = 0; i < this.values.length; i++) {
            this.values[i] += 1
            if (this.values[i] >= values.length) {
                this.values[i] = 0
            } else {
                return
            }
        }

        if (this.type === SequenceType.Numerical) {
            this.values.push(1)
        } else {
            this.values.push(0)
        }
    }

    subtractOne() {
        for (let i = 0; i < this.values.length; i++) {
            this.values[i] -= 1
            if (this.values[i] < 0) {
                const values = getPossibleValuesFromSequenceType(this.type)
                this.values[i] = values.length-1
            } else {
                return
            }
        }

        this.values = this.values.slice(0, this.values.length-1)
    }

    toStr() {
        let values = getPossibleValuesFromSequenceType(this.type)
        let str = ''
        for (let i = 0; i < this.values.length; i++) {
            str = values[this.values[i]] + str
        }

        return str
    }
}

class FullNumber {
    constructor(sections=[], seperator='-') {
        this.sections = sections
        this.seperator = seperator
        if (seperator === null) {
            this.seperator = '-'
        }
    }

    copy() {
        const newSections = []
        for (let i = 0; i < this.sections.length; i++) {
            newSections.push(this.sections[i].copy())
        }

        return new FullNumber(newSections, this.seperator)
    }

    equals(rhs) {
        if (!rhs) {
            return false
        }

        if (this.sections.length !== rhs.sections.length) {
            return false
        }

        if (this.seperator !== rhs.seperator) {
            return false
        }

        for (let i = 0; i < this.sections.length; i++) {
            if (!this.sections[i].equals(rhs.sections[i])) {
                return false
            }
        }

        return true
    }

    addOne(nextNumber) {
        this.sections[this.sections.length-1].addOne()
        if (this.equals(nextNumber)) {
            this.sections[this.sections.length-1].subtractOne()
            this.sections.push(new Section([0], this.sections[this.sections.length-1].type))
        }
    }

    toStr() {
        let str = ''
        for (let i = 0; i < this.sections.length; i++) {
            if (str !== '') {
                str += this.seperator
            }
            str += this.sections[i].toStr()
        }
        return str
    }
}

function parseIntoSections(str) {
    if (!str) {
        return null
    }

    let sections = []
    let splitChar = null
    let sectionType = null
    let numbers = []
    for (let i = 0; i < str.length; i++) {
        let cType = getSequenceType([str[i]], SequenceType.None)
        // Did hit split char
        if (cType === SequenceType.None) {

            if (splitChar === null) {
                splitChar = str[i]
            }

            // Using diferent split char or two in a row.
            // Must not have a pattern
            if (splitChar !== str[i] ||
                numbers.length === 0 || sectionType === null) {
                return null
            }

            sections.push(new Section(numbers.reverse(), sectionType))
            numbers = []
            sectionType = null

            continue
        }

        if (sectionType === null) {
            sectionType = cType
        }

        // Diferent type so maybe their is no pattern
        if (sectionType !== cType) {
            return null
        }

        // Add to number
        const values = getPossibleValuesFromSequenceType(sectionType)
        const index = values.indexOf(str[i])
        numbers.push(index)
    }

    if (numbers.length > 0) {
        sections.push(new Section(numbers.reverse(), sectionType))
    }

    return new FullNumber(sections, splitChar)
}

/**
 * @param {string} prevName
 * @param {string} nextName
 * @param {SequenceType} stype
 * @param {SequenceType} defaultType
 * @return {string}
 */
function giveName(prevName, nextName=null, stype=SequenceType.None,
    defaultType=SequenceType.UAlphabet) {

    const prevNumb = parseIntoSections(prevName)
    if (!prevNumb) { return null }
    const nextNumb = parseIntoSections(nextName)

    prevNumb.addOne(nextNumb)
    return prevNumb.toStr()
}

module.exports = {
    giveName,
    SequenceType,
}

